// src/components/Home.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import bgImage from "../assets/bg.png";
import logo from "../assets/logo.png";
import { motion } from "framer-motion";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

const Home = () => {
    const navigate = useNavigate();
    const { login, register, isAuthenticated, user, getToken } = useKindeAuth();

    useEffect(() => {
        const handleAuth = async () => {
            console.log("isAuthenticated:", isAuthenticated);
            console.log("user:", user);
            if (isAuthenticated && user) {
                const accessToken = await getToken();
                if (accessToken) {
                    // Save user data and token to localStorage.
                    localStorage.setItem("username", user.given_name); // Update key if necessary.
                    localStorage.setItem("email", user.email); // Update key if necessary.
                    localStorage.setItem("accessToken", accessToken);

                    // Redirect to dashboard.
                    navigate("/dashboard");
                }
            }
        };

        handleAuth();
    }, [isAuthenticated, user, getToken, navigate]);

    return (
        <div
            className="min-h-[100svh] flex items-center justify-center bg-gray-100 px-4 bg-cover bg-center"
            style={{ backgroundImage: `url(${bgImage})` }}
        >
            <motion.div
                initial={{ opacity: 0, y: 24, scale: 0.97 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
                className="w-full max-w-xl"
            >
                <motion.div
                    initial={{ boxShadow: "0 0 0 rgba(0,0,0,0)" }}
                    animate={{ boxShadow: "0 18px 45px rgba(15,23,42,0.25)" }}
                    transition={{ delay: 0.1, duration: 0.4 }}
                    className="overflow-hidden rounded-2xl border border-gray-200/70 bg-black/70 backdrop-blur-sm"
                >
                    <div className="p-6 sm:p-8 space-y-8">
                        {/* Logo + app name */}
                        <div className="flex items-center gap-3">
                            <div className="flex h-10 w-10 items-center justify-center rounded bg-blue-600">
                                <img
                                    src={logo}
                                    alt="Logo"
                                    className="h-8 w-8 rounded bg-white/10 p-0.5"
                                />
                            </div>
                            <div className="flex flex-col text-left">
                                <span className="text-sm font-semibold uppercase tracking-wide text-blue-200">
                                    Data Enhancer
                                </span>
                                <span className="text-xs text-gray-300">
                                    Enrich and explore your data
                                </span>
                            </div>
                        </div>

                        {/* Title + description */}
                        <div className="space-y-2 text-left">
                            <h1 className="text-2xl sm:text-3xl font-semibold text-white">
                                Welcome to Data Enhancer
                            </h1>
                            <p className="text-sm sm:text-base text-gray-200">
                                Sign in to access dashboards, enrichment tools, and AI-powered insights
                                tailored to your datasets.
                            </p>
                        </div>

                        {/* Call to action */}
                        <motion.div
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.18, duration: 0.35 }}
                            className="space-y-3"
                        >
                            <div className="flex flex-col sm:flex-row gap-3">
                                {/* Primary sign-in */}
                                <motion.button
                                    type="button"
                                    onClick={() => login()}
                                    whileHover={{ scale: 1.015 }}
                                    whileTap={{ scale: 0.98 }}
                                    className="inline-flex flex-1 items-center justify-center gap-2 rounded-lg bg-yellow-500 px-4 py-3 text-sm font-semibold text-slate-900 shadow-md transition hover:bg-yellow-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400/70"
                                >
                                    Sign in to continue
                                </motion.button>

                                {/* Switch to external token sign-in */}
                                <motion.button
                                    type="button"
                                    onClick={() => navigate("/external")}
                                    whileHover={{ scale: 1.015 }}
                                    whileTap={{ scale: 0.98 }}
                                    className="inline-flex flex-1 items-center justify-center gap-2 rounded-lg border border-gray-500/70 bg-transparent px-4 py-3 text-sm font-semibold text-gray-200 shadow-sm transition hover:bg-white/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400/70"
                                >
                                    Use access token
                                </motion.button>
                            </div>

                            <p className="text-xs text-gray-300 text-center">
                                Sign in with secure authentication powered by Kinde.
                            </p>
                        </motion.div>
                    </div>
                </motion.div>
            </motion.div>
        </div>
    );
};

export default Home;
